import { Tabs, Checkbox, Tag } from "antd";
import { useState } from "react";
import { Sites } from "../app";

const { TabPane } = Tabs;

interface UserHuntTabsProps {
  sites: [Sites] | undefined;
  onSelectAll: (siteName: keyof Sites, isSelected: boolean) => void;
  onSelect: (site: string, isSelected: boolean) => void;
  selectedSites: [string];
  checkedSites: any;
}

export const UserHuntTabs: React.FC<UserHuntTabsProps> = ({
  sites,
  selectedSites,
  onSelectAll,
  onSelect,
  checkedSites,
}) => {
  const [isSelectedSelectAll, setIsSelectedSelectAll] = useState<{
    [key: string]: boolean;
  }>({});

  const checkedSelectedSites = (val: string): boolean => {
    return selectedSites.includes(val);
  };

  const renderBadge = (site: any) => {
    if (site) {
      let color = "success";
      let displayText = "Available";
      switch (site.status) {
        case "Unknown":
          color = "grey";
          displayText = "Unknown";
          break;
        case "Claimed":
          color = "error";
          displayText = "Unavailable";
          break;
        case "Invalid":
          color = "warning";
          displayText = "Invalid";
          break;
      }
      return  <a href={site.urlUser} target="_blank" rel="noreferrer"><Tag color={color}>{displayText}</Tag></a>;
    }
  };

  const renderTabContent = (siteNames: any, category: string | number) => {
    return siteNames.map((site: any) => {
      return (
        <div key={site}>
          <Checkbox
            onChange={(event) => {
              setIsSelectedSelectAll({
                ...isSelectedSelectAll,
                [category]: false,
              });
              onSelect(site, event.target.checked);
            }}
            checked={checkedSelectedSites(site)}
          >
            {site}
          </Checkbox>
          {/* {Object.keys(checkedSites).length > 0 &&
            checkedSites[site] && 
            <a href={checkedSites[site].urlUser} target="_blank" rel="noreferrer"><i className="las la-external-link-alt" style={{paddingRight: '10px'}}></i></a>
          } */}

          {Object.keys(checkedSites).length > 0 &&
            renderBadge(checkedSites[site])}
        </div>
      );
    });
  };

  const handleSelectAll = (siteName: number) => {
    const isSelecting =
      isSelectedSelectAll[siteName] === undefined
        ? true
        : !isSelectedSelectAll[siteName];
    setIsSelectedSelectAll({
      ...isSelectedSelectAll,
      [siteName]: isSelecting,
    });
    onSelectAll(siteName, isSelecting);
  };

  return sites ? (
    <Tabs defaultActiveKey="1">
      {Object.keys(sites).map((siteName: keyof Sites, index) => {
        return (
          <TabPane tab={siteName} key={`${siteName}-${index}`}>
            <div className="select_all">
              <Checkbox
                checked={isSelectedSelectAll[siteName]}
                onChange={() => handleSelectAll(siteName as number)}
              >
                Select All
              </Checkbox>
            </div>
            <div className="checkbox__wrapper">
              {renderTabContent(sites[siteName as number], siteName)}
            </div>
          </TabPane>
        );
      })}
    </Tabs>
  ) : (
    <noscript />
  );
};